/**
 * Duck para pegar o resultado da conciliacao
 * @author Otávio Bastilho
 * @copyright 10/2019
 */

import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
	conciliationResult: ['result'],
	conciliationResultLoading: ['isLoading'],
	conciliationResultError: [],
	conciliationResultClean: [],
	getInvoiceLoading: [],
	getInvoiceComplete: [],
	getToast: [],
	fileCertificateSustainability: [],
	fileCertificateSustainabilityLoading: [],
	fileCertificateSustainabilityComplete: [],
	setLastCertificateDetails: [],
	setCertificateHistoryList: [],
	setLoadingStatusPage: [],
	setLoadingSustainabilitySave: [],
	setSustainabilityToast: [],
	setSustainabilityList: [],
	sustainabilityHasMoreLoading: [],
	cleanSustainabilityList: [],
	setSelectedCertificate: [],
	unsetSelectedCertificate: [],
	conciliationHistoryLoading: ['payload'],
	conciliationHistoryError: [],
	conciliationHistory: [],
	setConciliationList: [],
	setConciliationFilter: [],
	setConciliationListLoading: [],
	cleanConciliationList: [],
	udaSustainability: [],
	udaSustainabilityLoading: [],
	sustainabilityDetailsReload: [],
	downloadSustainabilityLoading: [],
	downloadSustainabilityFile: [],
	setSustainabilityCsvList: [],
	setModalConfirmCancel: [],
	setModalObservacao: [],
	setReloadConciliationResultPage: [],
	showMotivoReprovacaoModal: [],
	setLoadingSustainabilityReport: [],
	setUDADescription: []
});

/**
 * Handlers
 */
const INITIAL_STATE = {
	result: {},
	isLoading: false,
	error: undefined,
	isLoadingInvoice: false,
	fileCertificateSustainability: '',
	lastCertificateDetails: {
		buscarDetalhesUltimoCertificadoPorPedido: {},
	},
	certificateHistoryList: {
		buscarPorPedido: []
	},
	isloadingStatusPage: false,
	isloadingSustainabilitySave: false,
	sustainabilityStatusToast: {
		showToast: false,
        message: '',
        messageType: 'toast-success'
	},
	sustainabilityList: [],
	sustainabilityListPage: 1,
	sustainabilityListHasMore: true,
	sustainabilityHasMoreIsLoading: false,
	selectedCertificate: null,
	conciliationHistoryLoading: false,
	conciliationHistoryError: false,
	conciliationHistory: [],
	getToast: {
		showToast: false,
        message: '',
        messageType: 'toast-success'
	},
	conciliationList: [],
	filter: {
		conciliacao: '',
		pedido: '',
		nomeFornecedor: '',
		dataConciliacaoInicial: '',
		dataConciliacaoFinal: '',
		statusComercial: '',
		statusRFM: '',
		notaFiscal: '',
		orderBy: "pedido asc"
	},
	isLoadingConciliationList: false,
	conciliationListHasMore: true,
	conciliationListPage: 1,
	udaSustainability: '',
	udaSustainabilityLoading: false,
	reload: false,
	downloadSustainabilityLoading: false,
	downloadSustainabilityFile: undefined,
	sustainabilityCsvList: [],
	modalConfirmCancel: false,
	modalObservacao: false,
	reloadConciliationResultPage: false,
	modalMotivoReprovacao: {
		show: false,
		item: '',
		message: ''
	},
	isLoadingSustainabilityReport: false,
	defaultUDA: 1,
	udaDescription: ''
};

const conciliationResult = (state = INITIAL_STATE, action) => {
	return { ...state, result: action.payload };
}

const conciliationResultLoading = (state = INITIAL_STATE, action) => {
	return { ...state, isLoading: action.isLoading };
}

const conciliationResultError = (state = INITIAL_STATE, action) => {
	return { ...state, error: action.error };
}

const conciliationResultClean = (state = INITIAL_STATE, action) => {
	return { ...state, result: {} };
}

const getInvoiceLoading = (state = INITIAL_STATE, action) => {
	return { ...state, isLoadingInvoice: true };
}

const getInvoiceComplete = (state = INITIAL_STATE, action) => {
	return { ...state, isLoadingInvoice: false };
}

const getToast = (state = INITIAL_STATE, action) => {
    return {
        ...state, 
        getToast: {
            showToast: action.payload.showToast,
            message: action.payload.message,
            messageType: action.payload.messageType
        }
    };
}

const fileCertificateSustainability = (state = INITIAL_STATE, action) => {
	return { ...state, fileCertificateSustainability: action, defaultUDA: action.tipo };
}

const fileCertificateSustainabilityLoading = (state = INITIAL_STATE, action) => {
	return { ...state, isLoadingFileCertificateSustainability: true };
}

const fileCertificateSustainabilityComplete = (state = INITIAL_STATE, action) => {
	return { ...state, isLoadingFileCertificateSustainability: false };
}

const setLastCertificateDetails = (state = INITIAL_STATE, action) => {
	return { ...state, lastCertificateDetails: action.payload };
}

const setCertificateHistoryList = (state = INITIAL_STATE, action) => {
	return { ...state, certificateHistoryList: action.payload };
}

const setLoadingStatusPage = (state = INITIAL_STATE, action) => {
	return { ...state, isloadingStatusPage: action.payload };
}

const setLoadingSustainabilitySave = (state = INITIAL_STATE, action) => {
	return { ...state, isloadingSustainabilitySave: action.payload };
}

const setSustainabilityToast = (state = INITIAL_STATE, action) => {
    return {
        ...state, 
        sustainabilityStatusToast: {
            showToast: action.payload.showToast,
            message: action.payload.message,
            messageType: action.payload.messageType
        }
    };
}

const setSustainabilityList = (state = INITIAL_STATE, action) => {
    return { 
        ...state, 
        sustainabilityList: state.sustainabilityList.concat(action.payload.list),
        sustainabilityListHasMore: action.payload.hasMore,
        sustainabilityListPage: action.payload.page
    };
}

const sustainabilityHasMoreLoading = (state = INITIAL_STATE, action) => {
    return { ...state, sustainabilityHasMoreIsLoading: action.payload };
}

const cleanSustainabilityList = (state = INITIAL_STATE) => {
    return { ...state, sustainabilityList: [] };
}

const setSelectedCertificate = (state = INITIAL_STATE, action) => {
    return { ...state, selectedCertificate: action.payload };
}

const unsetSelectedCertificate = (state = INITIAL_STATE, action) => {
    return { ...state, selectedCertificate: null };
}

const conciliationHistory = (state = INITIAL_STATE, action) => {
	return { ...state, conciliationHistory: action.payload };
}

const conciliationHistoryLoading = (state = INITIAL_STATE, action) => {
	return { ...state, conciliationHistoryLoading: action.payload };
}

const conciliationHistoryError = (state = INITIAL_STATE, action) => {
	return { ...state, conciliationHistoryError: action.error };
}

const setConciliationFilter = (state = INITIAL_STATE, action) => {
    return { ...state, filter: action.payload };
}

const setConciliationListLoading = (state = INITIAL_STATE, action) => {
    return { ...state, isLoadingConciliationList: action.payload };
}

const setConciliationList = (state = INITIAL_STATE, action) => {
    return { 
        ...state, 
        conciliationList: state.conciliationList.concat(action.payload.list),
        conciliationListHasMore: action.payload.hasMore,
        conciliationListPage: action.payload.page
    };
}

const cleanConciliationList = (state = INITIAL_STATE, action) => {
    return { ...state, conciliationList: [] };
}

const udaSustainability = (state = INITIAL_STATE, action) => {
    return { ...state, udaSustainability: action.payload };
}

const udaSustainabilityLoading = (state = INITIAL_STATE, action) => {
    return { ...state, udaSustainabilityLoading: action.payload };
}

const sustainabilityDetailsReload = (state = INITIAL_STATE, action) => {
    return { ...state, reload: action.payload };
}

const downloadSustainabilityLoading = (state = INITIAL_STATE, action) => {
    return { ...state, downloadSustainabilityLoading: action.payload };
}

const downloadSustainabilityFile = (state = INITIAL_STATE, action) => {
    return { ...state, downloadSustainabilityFile: action.payload };
}

const setSustainabilityCsvList = (state = INITIAL_STATE, action) => {
	return { ...state, sustainabilityCsvList: action.payload };
}

const setModalConfirmCancel = (state = INITIAL_STATE, action) => {
	return { ...state, modalConfirmCancel: action.payload.show };
}

const setModalObservacao = (state = INITIAL_STATE, action) => {
	return { ...state, modalObservacao: action.payload.show };
}

const setReloadConciliationResultPage = (state = INITIAL_STATE, action) => {
	return { ...state, reloadConciliationResultPage: action.payload.reload };
}

const showMotivoReprovacaoModal = (state = INITIAL_STATE, action) => {
    return {
        ...state, 
        modalMotivoReprovacao: {
            show: action.show,
            item: action.item,
            message: action.message
        }
    };
}

const setLoadingSustainabilityReport = (state = INITIAL_STATE, action) => {
	return { ...state, isLoadingSustainabilityReport: action.payload };
}

const setUDADescription = (state = INITIAL_STATE, action) => {
	return { ...state, udaDescription: action.payload };
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
	[Types.CONCILIATION_RESULT]: conciliationResult,
	[Types.CONCILIATION_RESULT_LOADING]: conciliationResultLoading,
	[Types.CONCILIATION_RESULT_ERROR]: conciliationResultError,
	[Types.CONCILIATION_RESULT_CLEAN]: conciliationResultClean,
	[Types.GET_INVOICE_LOADING]: getInvoiceLoading,
	[Types.GET_INVOICE_COMPLETE]: getInvoiceComplete,
    [Types.GET_TOAST]: getToast,
	[Types.FILE_CERTIFICATE_SUSTAINABILITY]: fileCertificateSustainability,
	[Types.FILE_CERTIFICATE_SUSTAINABILITY_LOADING]: fileCertificateSustainabilityLoading,
	[Types.FILE_CERTIFICATE_SUSTAINABILITY_COMPLETE]: fileCertificateSustainabilityComplete,
	[Types.SET_LAST_CERTIFICATE_DETAILS]: setLastCertificateDetails,
	[Types.SET_CERTIFICATE_HISTORY_LIST]: setCertificateHistoryList,
	[Types.SET_LOADING_STATUS_PAGE]: setLoadingStatusPage,
	[Types.SET_LOADING_SUSTAINABILITY_SAVE]: setLoadingSustainabilitySave,
	[Types.SET_SUSTAINABILITY_TOAST]: setSustainabilityToast,
	[Types.SET_SUSTAINABILITY_LIST]: setSustainabilityList,
	[Types.SUSTAINABILITY_HAS_MORE_LOADING]: sustainabilityHasMoreLoading,
	[Types.CLEAN_SUSTAINABILITY_LIST]: cleanSustainabilityList,
	[Types.SET_SELECTED_CERTIFICATE]: setSelectedCertificate,
    [Types.UNSET_SELECTED_CERTIFICATE]: unsetSelectedCertificate,
	[Types.CONCILIATION_HISTORY_LOADING]: conciliationHistoryLoading,
	[Types.CONCILIATION_HISTORY_ERROR]: conciliationHistoryError,
	[Types.CONCILIATION_HISTORY]: conciliationHistory,
	[Types.SET_CONCILIATION_LIST]: setConciliationList,
	[Types.SET_CONCILIATION_FILTER]: setConciliationFilter,
	[Types.SET_CONCILIATION_LIST_LOADING]: setConciliationListLoading,
	[Types.CLEAN_CONCILIATION_LIST]: cleanConciliationList,
	[Types.UDA_SUSTAINABILITY]: udaSustainability,
	[Types.UDA_SUSTAINABILITY_LOADING]: udaSustainabilityLoading,
	[Types.SUSTAINABILITY_DETAILS_RELOAD]: sustainabilityDetailsReload,
	[Types.DOWNLOAD_SUSTAINABILITY_LOADING]: downloadSustainabilityLoading,
	[Types.DOWNLOAD_SUSTAINABILITY_FILE]: downloadSustainabilityFile,
	[Types.SET_SUSTAINABILITY_CSV_LIST]: setSustainabilityCsvList,
	[Types.SET_MODAL_CONFIRM_CANCEL]: setModalConfirmCancel,
	[Types.SET_MODAL_OBSERVACAO]: setModalObservacao,
	[Types.SET_RELOAD_CONCILIATION_RESULT_PAGE]: setReloadConciliationResultPage,
	[Types.SHOW_MOTIVO_REPROVACAO_MODAL]: showMotivoReprovacaoModal,
	[Types.SET_LOADING_SUSTAINABILITY_REPORT]: setLoadingSustainabilityReport,
	[Types.SET_UDA_DESCRIPTION]: setUDADescription,
});
